/**
 * Registro do service worker do AutEM 4.0 (instalação como aplicativo).
 *
 * O mesmo arquivo que já cuidava do push passa a ser registrado assim que o
 * painel abre, porque o Chrome só oferece "Instalar" quando existe service
 * worker ativo. Ele não guarda nada em cache, então não há risco de o usuário
 * ficar preso numa versão antiga.
 *
 * Só roda em produção: no preview e no desenvolvimento o service worker
 * atrapalha o recarregamento automático.
 *
 * Saída de emergência: publique com `REACT_APP_DISABLE_SW=1` e o próprio
 * carregamento remove o registro dos navegadores que já o pegaram.
 */

const ESCOPO = "/";
const ARQUIVO = "/service-worker.js";

async function removerRegistros() {
  const regs = await navigator.serviceWorker.getRegistrations();
  await Promise.all(regs.map((r) => r.unregister()));
}

export function registrarServiceWorker() {
  if (typeof navigator === "undefined" || !("serviceWorker" in navigator)) return;

  const desligado = process.env.REACT_APP_DISABLE_SW === "1";
  if (desligado || process.env.NODE_ENV !== "production") {
    // Em desenvolvimento também limpa, para quem já tem um registro antigo do
    // push preso no navegador.
    void removerRegistros().catch(() => {});
    return;
  }

  window.addEventListener("load", () => {
    navigator.serviceWorker.register(ARQUIVO, { scope: ESCOPO }).catch(() => {
      // Sem service worker o painel funciona igual, só não oferece instalação.
    });
  });
}
